<template>
  <b-tab title="Overview" active>
    <b-card-text>
      <table class="table">
        <tbody>
          <!--
        <tr>
          <td>Record type</td>
          <td>{{result.sem_record_type}}</td>
        </tr>
        -->
          <tr>
            <td>{{ $t("scifund.labels.linktotopic") }}</td>
            <td>
              <b-link
                v-if="result.sem_source_id == 'Draft'"
                target="_blank"
                :href="
                  '/api/sl/file?name=' +
                    result.sem_file_name +
                    '&access_token=' +
                    this.authenticated
                "
              >
                {{ $t("scifund.labels.draft") }}
              </b-link>
              <div v-else>
                <b-link
                  target="_blank"
                  :href="
                    'https://ec.europa.eu/info/funding-tenders/opportunities/portal/screen/opportunities/topic-details/' +
                      toLowerCase(result.id)
                  "
                >
                  {{ $t("scifund.labels.linktoeuportal") }}
                </b-link>
              </div>
            </td>
          </tr>
          <tr>
            <td>{{ $t("scifund.labels.id") }}</td>
            <td>{{ result.id }}</td>
          </tr>
          <tr v-if="result.sem_publication_date">
            <td>{{ $t("scifund.labels.Publication_Date") }}</td>
            <td>{{ result.sem_publication_date | moment("DD. MMM YYYY") }}</td>
          </tr>
          <tr v-if="result.action_plannedOpeningDates">
            <td>{{ $t("scifund.labels.Opening_Date") }}</td>
            <td>
              {{
                result.action_plannedOpeningDates[0] | moment("DD. MMM YYYY")
              }}
            </td>
          </tr>
          <tr v-if="result.action_deadlineDates">
            <td>{{ $t("scifund.labels.Deadline_Dates") }}</td>
            <td>
              <span
                v-for="(x, i) in result.action_deadlineDates"
                :key="'deadlines' + i"
                >{{ x | moment("DD. MMM YYYY") }}<br
              /></span>
            </td>
          </tr>
          <tr v-if="result.frameworkProgramme">
            <td>{{ $t("scifund.labels.Framework_Programme") }}</td>
            <td>{{ result.frameworkProgramme }}</td>
          </tr>
          <tr v-if="result.programmeDivision">
            <td>{{ $t("scifund.labels.Programme_Division") }}</td>
            <td>
              <span v-for="x in result.programmeDivision" :key="x"
                >{{ x }}<br
              /></span>
            </td>
          </tr>
          <tr v-if="result.workProgrammeTitle">
            <td>{{ $t("scifund.labels.Work_Programme_Title") }}</td>
            <td>
              {{ result.workProgrammeTitle }}<br />
              <b-link
                v-if="result.wp_document"
                target="_blank"
                :href="result.wp_document"
              >
                {{ $t("scifund.labels.linktodocument") }} </b-link
              ><br />
              <b-link
                v-if="result.wp_website"
                target="_blank"
                :href="result.wp_website"
              >
                {{ $t("scifund.labels.linktowebsite") }}
              </b-link>
            </td>
          </tr>
          <tr v-if="result.focusArea">
            <td>{{ $t("scifund.labels.Focus_Area") }}</td>
            <td>{{ result.focusArea }}</td>
          </tr>
          <tr v-if="result.callIdentifier">
            <td>{{ $t("scifund.labels.Call_Identifier") }}</td>
            <td>{{ result.callIdentifier }}</td>
          </tr>
          <tr v-if="result.callTitle">
            <td>{{ $t("scifund.labels.Call_Title") }}</td>
            <td>{{ result.callTitle }}</td>
          </tr>
          <tr v-if="result.destinationDescription">
            <td>{{ $t("scifund.labels.Destination") }}</td>
            <td>{{ result.destinationDescription }}</td>
          </tr>

          <tr v-if="result.missionDescription">
            <td>{{ $t("scifund.labels.Mission") }}</td>
            <td>{{ result.missionDescription }}</td>
          </tr>

          <tr v-if="result.trl_all">
            <td>{{ $t("scifund.labels.TRL_All") }}</td>
            <td>
              <span v-for="x in result.trl_all" :key="'trlall' + x"
                >/ {{ x }} /</span
              >
            </td>
          </tr>
          <tr v-if="result.trl_start">
            <td>{{ $t("scifund.labels.TRL_Prerequisite") }}</td>
            <td>
              <span v-for="x in result.trl_start" :key="'trlstart' + x"
                >/ {{ x }} /</span
              >
            </td>
          </tr>
          <tr v-if="result.trl_end">
            <td>{{ $t("scifund.labels.TRL_Target") }}</td>
            <td>
              <span v-for="x in result.trl_end" :key="'trlend' + x"
                >/ {{ x }} /</span
              >
            </td>
          </tr>
          <tr v-if="result.action_types">
            <td>{{ $t("scifund.labels.Action_Type") }}</td>
            <td>
              <span v-for="(x, i) in result.action_types" :key="x + i"
                >{{ x }}<br
              /></span>
            </td>
          </tr>
          <tr v-if="result.topic_status_s">
            <td>Overall status</td>
            <td>
              <span>{{ result.topic_status_s }}<br /></span>
            </td>
          </tr>
          <tr v-if="result.action_statuses">
            <td>{{ $t("scifund.labels.Action_Status") }}</td>
            <td>
              <span
                v-for="(x, index) in result.action_statuses"
                :key="result.id + '-action_status-' + index"
                >{{ x }}<br
              /></span>
            </td>
          </tr>
          <tr v-if="result.budget_total">
            <td>{{ $t("scifund.labels.Budget_Total") }}</td>
            <td>
              <span
                v-for="(x, i) in result.budget_total"
                :key="'budgettotal' + i"
                >{{ formatBudget(x) }}<br
              /></span>
            </td>
          </tr>
          <tr v-if="this.budgets">
            <td>{{ $t("scifund.labels.Details_Actions_Budget") }}</td>

            <td>
              <div v-for="(x, i) in this.budgets" :key="x.action + i">
                {{ x.action }}<br />
                {{ $t("scifund.labels.plannedOpeningDate") }}:
                <span class="mr-1 badge badge-white">{{
                  x.plannedOpeningDate
                }}</span
                ><br />
                {{ x.deadlineModel }} {{ $t("scifund.labels.deadlines") }}:
                <span
                  v-for="(y, j) in x.deadlineDates"
                  :key="x.action + i + 'deadlines' + j"
                >
                  <span class="mr-1 badge badge-white">{{ y }}</span></span
                >
                <br /><br />
                <span v-if="x.budgetYearMap"
                  ><i>{{ $t("scifund.labels.budgetPerYear") }}:</i></span
                ><br />
                <span
                  v-for="(v, k) in x.budgetYearMap"
                  :key="x.action + i + 'budget' + k"
                >
                  {{ k }}: {{ formatBudget(v) }}<br />
                </span>
                <hr />
              </div>
            </td>
          </tr>
          <tr v-if="result.eligible_countries_ss">
            <td>{{ $t("scifund.labels.Eligible_Countries") }}</td>
            <td>
              <span
                v-for="(x, i) in result.eligible_countries_ss"
                :key="'eligiblecountries' + i"
                >{{ x }}<br
              /></span>
            </td>
          </tr>
          <tr v-if="result.topicMGAs">
            <td>{{ $t("scifund.labels.topicMGAs") }}</td>
            <td>
              <span v-for="(x, i) in result.topicMGAs" :key="'topicMGAs' + i"
                >{{ x }}<br
              /></span>
            </td>
          </tr>

          <tr v-if="result.sme">
            <td>{{ $t("scifund.labels.SME_Participation") }}</td>
            <td>{{ result.sme }}</td>
          </tr>
          <tr v-if="result.cftId">
            <td>cftId</td>
            <td>{{ result.cftId }}</td>
          </tr>
          <tr v-if="result.ccm2Id">
            <td>ccm2Id</td>
            <td>{{ result.ccm2Id }}</td>
          </tr>
          <tr v-if="result.callccm2Id">
            <td>callccm2Id</td>
            <td>{{ result.callccm2Id }}</td>
          </tr>
        </tbody>
      </table>

      <h3 v-if="result.keywords" class="mt-4">Keywords</h3>
      <span
        v-for="x in result.keywords"
        class="mr-1 badge badge-light"
        :key="'keywords' + x"
        >{{ x }}</span
      >&nbsp;

      <h3 v-if="result.sem_tags" class="mt-4">Tags</h3>
      <span
        v-for="x in result.sem_tags"
        class="mr-1 badge badge-light"
        :key="'tags' + x"
        >{{ x }}</span
      >&nbsp;

      <h3 class="mt-4">Description</h3>
      <div
        v-if="result.description && result.description.length > 12"
        v-html="result.description"
      ></div>
      <div v-else><span>no description available</span></div>
      <!--
    <p v-for="(x,index) in result.sem_content">
    <span v-html="x"></span>
    </p>
    -->

      <h3 v-if="result.sem_links">Links</h3>
      <a
        v-for="x in result.sem_links"
        class=""
        :key="x"
        :href="x"
        target="_blank"
        >{{ x }}</a
      >&nbsp;
    </b-card-text>
  </b-tab>
</template>

<script>
window.$ = require("jquery");

export default {
  name: "resultTopic",
  props: ["result"],
  computed: {
    budgets() {
      if (!this.result.budgets) return null;

      var budget_array = [];
      for (var i = 0; i < this.result.budgets.length; i++) {
        budget_array.push(JSON.parse(this.result.budgets[i]));
      }
      return budget_array;
    },
    authenticated() {
      return this.$store.state.authenticated;
    },
  },
  methods: {
    formatBudget: function(v) {
      return JSON.stringify(v).replaceAll(/(\d+)(0{6})\b/g, "$1M");
    },
    toLowerCase: function(str) {
      return str.toLowerCase();
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.$(document).ready(function() {
        window.$("a").each(function() {
          if (
            window.$(this).attr("href") &&
            (window
              .$(this)
              .attr("href")
              .startsWith("#r") ||
              window
                .$(this)
                .attr("href")
                .startsWith("#f"))
          ) {
            window.$(this).removeAttr("href");
            window.$(this).addClass("disabledFooterLink");
          } else if (
            window.$(this).attr("href") &&
            (window
              .$(this)
              .attr("href")
              .startsWith("//") ||
              window
                .$(this)
                .attr("href")
                .startsWith("http"))
          ) {
            window.$(this).attr("target", "_blank");
          }
        });
      });
    });
  },
};
</script>

<style scoped></style>
